// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GeoDbImport__geoDbImport___nAlfG {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    width: 32rem;

    border-right: 0.1rem solid var(--color-bg-border);
}

.GeoDbImport__dbWrapper___P9qBQ {
    margin: 0.8rem;
}

.GeoDbImport__dbContainer___xuJ5H {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.GeoDbImport__geoDbImportTree___t5Nao {
    overflow: auto;
    display: flex;
    flex-grow: 1;
}

.GeoDbImport__findWrapper___QcnsG {
    display: flex;
    align-items: center;
}

.GeoDbImport__info___HxLdZ {
    display: flex;
    align-items: center;
    padding-right: 0.8rem;
    padding-left: 0.8rem;
}

.GeoDbImport__btnAdd___etInq {
    margin: 0.8rem;
}

.GeoDbImport__skeletonWrapper___fdrAW {
    display: flex;
}

.GeoDbImport__skeleton___j2MPT {
    margin-top: auto;
    margin-bottom: auto;
}

.GeoDbImport__searchText___zjRDx {
    margin-top: 0.8rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/GeoDbImport/GeoDbImport.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;;IAE9B,YAAY;;IAEZ,iDAAiD;AACrD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".geoDbImport {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    width: 32rem;\n\n    border-right: 0.1rem solid var(--color-bg-border);\n}\n\n.dbWrapper {\n    margin: 0.8rem;\n}\n\n.dbContainer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.geoDbImportTree {\n    overflow: auto;\n    display: flex;\n    flex-grow: 1;\n}\n\n.findWrapper {\n    display: flex;\n    align-items: center;\n}\n\n.info {\n    display: flex;\n    align-items: center;\n    padding-right: 0.8rem;\n    padding-left: 0.8rem;\n}\n\n.btnAdd {\n    margin: 0.8rem;\n}\n\n.skeletonWrapper {\n    display: flex;\n}\n\n.skeleton {\n    margin-top: auto;\n    margin-bottom: auto;\n}\n\n.searchText {\n    margin-top: 0.8rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"geoDbImport": `GeoDbImport__geoDbImport___nAlfG`,
	"dbWrapper": `GeoDbImport__dbWrapper___P9qBQ`,
	"dbContainer": `GeoDbImport__dbContainer___xuJ5H`,
	"geoDbImportTree": `GeoDbImport__geoDbImportTree___t5Nao`,
	"findWrapper": `GeoDbImport__findWrapper___QcnsG`,
	"info": `GeoDbImport__info___HxLdZ`,
	"btnAdd": `GeoDbImport__btnAdd___etInq`,
	"skeletonWrapper": `GeoDbImport__skeletonWrapper___fdrAW`,
	"skeleton": `GeoDbImport__skeleton___j2MPT`,
	"searchText": `GeoDbImport__searchText___zjRDx`
};
export default ___CSS_LOADER_EXPORT___;
